__turbopack_context__.v({
  "backBtn": "STNewsDetail-module__s76aXa__backBtn",
  "detailTable": "STNewsDetail-module__s76aXa__detailTable",
  "divider": "STNewsDetail-module__s76aXa__divider",
  "iconBtn": "STNewsDetail-module__s76aXa__iconBtn",
  "logoImgWrap": "STNewsDetail-module__s76aXa__logoImgWrap",
  "newsImageWrap": "STNewsDetail-module__s76aXa__newsImageWrap",
});
